import axios from "axios";
import {getAuthorization} from "./util.service";
import {checkEmpty} from "src/utils/janus.utils";
import {getClassAndType, getFinalNameChat} from "./files.util";
import {getToken, getUserData} from "./auth.service";
import {v4 as uuidv4} from "uuid";
import {imgTypes, videoType} from "src/props/util.props";

export const APIFileEnpoint = {
  getFiles: "/getFiles",
  getFilesInTash: "/getFilesInTash",
  files: "api/v1/files",
  manageversions: "/getFilesAllVersion",
};
let limit: any = window.__RUNTIME_CONFIG__.REACT_APP_UPLOAD_LIMIT_PER_FILE;
export let chunkSize = parseInt(limit) * 1024 * 1024; // Size of each chunk, set to 1 Mb
// Blob. slice method is used to segment files.
// At the same time, this method is used in different browsers in different ways.
let blobSlice = File.prototype.slice;
const caches: any = {};
export async function createFolderRequest(
  fileName: string,
  groupId: string,
  userId: string,
  parentFolderId: string,
  entryp: boolean,
  controlVersion: boolean
) {
  let paramemers = {
    fileName: fileName.trim(),
    userId: checkEmpty(userId) ? "" : userId,
    groupId: checkEmpty(groupId) ? "" : groupId,
    parentFolderId: parentFolderId,
    entryp: entryp,
    controlVersion: controlVersion,
  };
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/createFolder";
  return new Promise((resolve, reject) => {
    axios
      .post(link, paramemers, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        let folder = Object.assign({}, response.data.data);
        resolve(folder);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {});
  });
}

export async function getLsItem(
  type: string,
  parentFolderId: string,
  groupId: string,
  userId: string
) {
  let param = {
    groupId: groupId,
    userId: userId,
    offset: 0,
    parentFolderId: parentFolderId,
  };
  let res: any = await getFiles(param);
  let fileFoldersT = res.data;
  if (checkEmpty(fileFoldersT)) fileFoldersT = [];
  let lstemp = fileFoldersT.filter((item: any) => {
    return item.type_ === type;
  });
  return lstemp;
}

export async function getFiles(paramemersFile: any) {
  return new Promise((resolve, reject) => {
    let CancelToken = axios.CancelToken;
    let requestAxiosCancel = null;
    let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/getFiles";
    axios
      .get(link, {
        params: paramemersFile,
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
        cancelToken: new CancelToken(function executor(c) {
          requestAxiosCancel = c;
        }),
      })
      .then(function (response) {
        resolve({ data: response.data.data, total: response.data.total });
      })
      .catch(function (error) {
        if (axios.isCancel(error)) {
          console.log("request cancelled");
        } else {
          console.log("some other reason");
        }
        reject(error);
      })
      .finally(function () {
        // always executed
      });
    // let axiosGetFilesRequestIdsTemp = axiosGetFilesIds;
    // axiosGetFilesRequestIdsTemp.push(requestAxiosCancel);
    // setAxiosGetFilesIds(axiosGetFilesRequestIdsTemp);
  });
}

export const checkFileCanUploadBackend = (file: any, currentFolder: any) => {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/checkFileCanUpload";
  let currentFolderId = "";
  if (!checkEmpty(currentFolder?.file_app_id))
    currentFolderId = currentFolder?.file_app_id;
  let p = {
    currentFolderId: currentFolderId,
    fileName: file.name_,
    fileType: file.type_,
  };
  return new Promise((resolve, reject) => {
    let data = { can: false };
    axios
      .get(link, {
        params: p,
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        let data = response.data.data;
        resolve(data);
      })
      .catch(function (error) {
        resolve(data);
      })
      .finally(function () {});
  });
};

export async function getAboutLimitMain(param: any) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/getAboutLimit";
  return new Promise((resolve, reject) => {
    axios
      .get(link, {
        params: param,
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function getCurrentSharedWithCallService(param: any) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/getSharedWithMeDetail";
  return new Promise((resolve, reject) => {
    axios
      .get(link, {
        params: param,
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function uploadFileRequest(
  files: any,
  groupId: any,
  userId: any,
  currentFolder: any,
  isCheckIn: any,
  fileSelected: any,
  fileContext: any
) {
  return new Promise((resolve, reject) => {
    let sizeAll = files.length,
      checkFinish = 0,
      checkError = 0;
    let parentFolderId = "";
    if (!checkEmpty(currentFolder?.file_app_id))
      parentFolderId = currentFolder?.file_app_id;

    let lsFileUpload: any = [];
    for (let a = 0; a < files.length; a++) {
      let file = files[a];

      let usedId = null;
      let useName = file.name_;
      if (isCheckIn) {
        usedId = fileSelected.file_app_id;
        useName = fileSelected.file_name;
      }

      let CancelToken = axios.CancelToken;
      let cancel: any;

      let data = new FormData();
      // let d = getClassAndType(file.name);
      data.append("file", file);
      data.append("fileName", useName);
      data.append("userId", userId);
      data.append("groupId", groupId);
      data.append("parentFolderId", parentFolderId);
      data.append("cancelCheckOut", isCheckIn);
      data.append("cancelCheckOutFileId", usedId);
      let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/upload";
      let config = {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
        onUploadProgress: (progress: any) => {
          onUploadProgress(
            progress,
            file,
            fileContext,
            cancel,
            null,
            null,
            null,
            null
          );
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      };

      axios
        .post(link, data, config)
        .then(function (response) {
          let fileT = Object.assign({}, response.data.data);
          lsFileUpload.push(fileT);
        })
        .catch(function (error) {
          checkError++;
          if (axios.isCancel(error)) {
            oncancelUpload(file, fileContext, "cancel");
          } else {
            console.log("some other reason", error);
            oncancelUpload(file, fileContext, "error");
          }
        })
        .finally(function () {
          checkFinish++;
          if (checkFinish === sizeAll && checkError === 0) {
            resolve(lsFileUpload);
          } else if (checkFinish === sizeAll && checkError != 0) {
            resolve(lsFileUpload);
          }
        });
    }
  });
}

export async function uploadFileRequestChunk(
  files: any,
  groupId: any,
  userId: any,
  currentFolder: any,
  isCheckIn: any,
  fileSelected: any,
  fileContext: any
) {
  return new Promise((resolve, reject) => {
    let sizeAll = files.length,
      checkFinish = 0,
      checkError = 0;
    let parentFolderId = "";
    if (!checkEmpty(currentFolder?.file_app_id))
      parentFolderId = currentFolder?.file_app_id;

    let lsFileUpload: any = [];
    let fileTemps: any = [];
    for (let a = 0; a < files.length; a++) {
      let file = files[a];

      let usedId: any = null;
      let useName = file.name_;
      if (isCheckIn) {
        usedId = fileSelected.file_app_id;
        useName = fileSelected.file_name;
      }

      let blockCount = Math.ceil(file.size / chunkSize); // total number of fragments
      console.log("a ", a);

      let hash = uuidv4();
      console.log("hash", hash);
      let axiosPromiseArray = [];

      let fileTemp: any = { loaded: 0 };
      fileTemps[a] = fileTemp;

      console.log(a, blockCount);
      for (let i = 0; i < blockCount; i++) {
        let CancelToken = axios.CancelToken;
        let cancel: any;
        const start = i * chunkSize;
        const end = Math.min(file.size, start + chunkSize);
        // Building forms
        const form = new FormData();
        form.append("file", blobSlice.call(file, start, end));
        form.append("name", useName);
        //@ts-ignore
        form.append("total", blockCount);
        //@ts-ignore
        form.append("index", i);
        form.append("size", file.size);
        //@ts-ignore
        form.append("hash", hash);

        // Ajax submits fragmentation, where content-type is multipart/form-data

        const axiosOptions = {
          onUploadProgress: (e: any) => {
            // Progress in handling uploads
            let progress: any = {};
            let loaded = fileTemps[a].loaded + e.loaded;
            progress.total = file.size;
            progress.loaded = loaded;
            if (e.loaded === e.total) {
              fileTemps[a].loaded = fileTemps[a].loaded + e.total;
            }

            // console.log(progress.total + "/" + progress.loaded);
            // console.log(i, (progress.loaded / progress.total) * 100);

            onUploadProgress(
              progress,
              file,
              fileContext,
              cancel,
              useName,
              hash,
              i,
              blockCount
            );
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: getAuthorization(),
          },
          cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancel = c;
          }),
        };
        // Add to Promise array
        let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/uploadSplit";
        axiosPromiseArray.push(axios.post(link, form, axiosOptions));
      }
      // After all fragments are uploaded, request to merge the fragmented files
      console.log("a ", a, axiosPromiseArray);
      axios
        .all(axiosPromiseArray)
        // eslint-disable-next-line no-loop-func
        .then(() => {
          let CancelToken = axios.CancelToken;
          let cancel: any;

          let config = {
            cancelToken: new CancelToken(function executor(c) {
              // An executor function receives a cancel function as a parameter
              cancel = c;
            }),
            onUploadProgress: (progress: any) => {
              // onUploadProgress(progress, file, fileContext, cancel);
              let progressT: any = {};
              progressT.total = file.size;
              progressT.loaded = file.size;
              onUploadProgress(
                progressT,
                file,
                fileContext,
                cancel,
                useName,
                hash,
                null,
                blockCount
              );
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: getAuthorization(),
            },
          };

          let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/merge_chunks";
          // Merge chunks
          console.log("file : ", file);
          const data = {
            size: file.size,
            name: useName + "." + file.type_,
            total: blockCount,

            fileName: useName,
            userId: userId,
            groupId: groupId,
            parentFolderId: parentFolderId,
            cancelCheckOut: isCheckIn,
            cancelCheckOutFileId: usedId,
            hash: hash,
            mimeType: file.type,
          };
          axios
            .post(link, data, config)
            .then((res) => {
              console.log("successful upload");
              console.log(res.data, file);
              checkFinish++;
              if (checkFinish === sizeAll && checkError === 0) {
                resolve(lsFileUpload);
              } else if (checkFinish === sizeAll && checkError != 0) {
                resolve(lsFileUpload);
              }
              let progressT: any = {};
              progressT.total = file.size;
              progressT.loaded = file.size;
              onUploadProgress(
                progressT,
                file,
                fileContext,
                cancel,
                useName,
                hash,
                null,
                blockCount
              );

              let fileT = Object.assign({}, res.data.data);
              lsFileUpload.push(fileT);
            })
            .catch(function (error) {
              checkError++;
              if (axios.isCancel(error)) {
                oncancelUpload(file, fileContext, "cancel");
              } else {
                console.log("some other reason", error);
                oncancelUpload(file, fileContext, "error");
              }
            })
            .finally(function () {
              console.log("finally upload");
            });
        })
        .catch(function (error) {
          checkError++;
          if (axios.isCancel(error)) {
            oncancelUpload(file, fileContext, "cancel");
          } else {
            console.log("some other reason", error);
            oncancelUpload(file, fileContext, "error");
          }
        });
    }
  });
}

export async function uploadFileRequestChunkChat(item: any, groupId: any) {
  return new Promise(async (resolve, reject) => {
    let lsFileUpload: any = [];
    let fileTemps: any = [];

    let hash = uuidv4();
    let axiosPromiseArray: any = [];
    let file = item;

    let usedId: any = null;
    let temp = getClassAndType(file.name);
    let useName = await getFinalNameChat(
      temp.name_,
      temp.type_,
      groupId,
      "chat"
    );
    let blockCount = Math.ceil(file.size / chunkSize);

    for (let i = 0; i < blockCount; i++) {
      let CancelToken = axios.CancelToken;
      let cancel: any;
      const start = i * chunkSize;
      const end = Math.min(file.size, start + chunkSize);
      // Building forms
      const form = new FormData();
      form.append("file", blobSlice.call(file, start, end));
      form.append("name", useName);
      //@ts-ignore
      form.append("total", blockCount);
      //@ts-ignore
      form.append("index", i);
      form.append("size", file.size);
      //@ts-ignore
      form.append("hash", hash);

      // Ajax submits fragmentation, where content-type is multipart/form-data

      const axiosOptions = {
        onUploadProgress: (e: any) => {},
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
      };
      // Add to Promise array
      let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/uploadSplit";
      axiosPromiseArray.push(axios.post(link, form, axiosOptions));
    }
    // After all fragments are uploaded, request to merge the fragmented files

    axios
      .all(axiosPromiseArray)
      .then(() => {
        let CancelToken = axios.CancelToken;
        let cancel: any;

        let config = {
          cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancel = c;
          }),
          onUploadProgress: (progress: any) => {},
          headers: {
            "Content-Type": "application/json",
            Authorization: getAuthorization(),
          },
        };

        let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/merge_chunks";
        // Merge chunks
        console.log("file : ", file);
        const data = {
          size: file.size,
          name: useName + "." + temp.type_,
          total: blockCount,

          fileName: useName,
          userId: null,
          groupId: groupId,
          parentFolderId: "",
          cancelCheckOut: null,
          cancelCheckOutFileId: null,
          hash: hash,
          mimeType: file.type,
          actionType: "chat",
        };

        /*
      data.append("file", item);
      data.append("fullName", item?.name);
      data.append("fileName", item?.name?.split(".")[0]);
      data.append("fileType", item?.name?.split(".")[1]);
      data.append("size", item?.size);
      data.append("groupId", props.currentGroupId);
      data.append("parent_folder_id", "");
      data.append("actionType", "chat");
      */

        axios
          .post(link, data, config)
          .then((res) => {
            console.log("successful upload");
            resolve(res.data);
          })
          .catch(function (error) {
            reject(error);
          })
          .finally(function () {
            console.log("finally upload");
          });
      })
      .catch(function (error) {});
  });
}

function oncancelUpload(file: any, fileContext: any, status: any) {
  let fileToUploadShowT = Object.assign([], fileContext.fileToUpload);
  let i = fileToUploadShowT.findIndex((item: any) => {
    return item.name_ === file.name_ && item.type_ === file.type_;
  });
  let fileT = fileToUploadShowT[i];
  if (!checkEmpty(fileT)) {
    fileT.status = status;
    fileToUploadShowT[i] = fileT;
    fileContext.setFileToUpload(Object.assign([], fileToUploadShowT));
  }
}

function onUploadProgress(
  progressEvent: any,
  file: any,
  fileContext: any,
  cancel: any,
  useName: any,
  hash: any,
  index: any,
  total: any
) {
  let temp = file;
  // console.log("progressEvent : ",progressEvent)
  let fileToUploadShowT = Object.assign([], fileContext.fileToUpload);
  let i = fileToUploadShowT.findIndex((item: any) => {
    return item.name_ === file.name_ && item.type_ === file.type_;
  });
  var percent = (progressEvent.loaded / progressEvent.total) * 100;
  percent = Math.round(percent);
  let fileT = fileToUploadShowT[i];
  if (!checkEmpty(fileT)) {
    if (fileT.status !== "cancel") {
      if (checkEmpty(fileT.percent) || percent > fileT.percent)
        fileT.percent = percent;
        fileT.status = "progress";
        fileT.useName = useName;
        fileT.hash = hash;
        fileT.loaded = progressEvent.loaded;
        fileT.total = total;
        fileT.file = temp;
      let cancels = fileT.cancel;
      if (checkEmpty(cancels)) {
        cancels = [];
      }
      if (!checkEmpty(index)) {
        cancels[index] = cancel;
      }
      fileT.cancel = cancels;
      if (percent === 100) {
        fileT.status = "done";
      }
      fileT.show = true;
    }

    fileToUploadShowT[i] = fileT;
    fileContext.setFileToUpload(Object.assign([], fileToUploadShowT));
  }
}

export async function getCurrentFolderMain(paramemersCurrentFolder: any) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/getCurrentFolder";
  return new Promise((resolve, reject) => {
    axios
      .get(link, {
        params: paramemersCurrentFolder,
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function getFileFoldersMethodGet(
  param: any,
  link: any,
  fileContext: any
) {
  let idsTemp = fileContext.fileAbouts;
  console.log("idsTemp", idsTemp);
  for (let a = 0; a < idsTemp.length; a++) {
    try {
      let lastref = localStorage.getItem("lastreffile");
      // if (lastref != idsTemp[a].key) {
      // idsTemp[a]?.cancel();
      // }
    } catch (e) {}
  }
  idsTemp = [];
  let CancelToken = axios.CancelToken;
  let requestAxiosCancel: any = null;

  return new Promise((resolve, reject) => {
    axios
      .get(link, {
        params: param,
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          requestAxiosCancel = c;
        }),
      })
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });

    let axiosGetFilesRequestIdsTemp = idsTemp;
    let ref = uuidv4();
    let item = { ref: ref, cancel: requestAxiosCancel };
    localStorage.setItem("lastreffile", ref);
    axiosGetFilesRequestIdsTemp.push(item);
    fileContext.setFileAbouts(axiosGetFilesRequestIdsTemp);
  });
}

export async function cancelUpload(useName: any, hash: any) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/cancelUploadSplit";
  return new Promise((resolve, reject) => {
    let paramemers = { name: useName, hash: hash };
    axios
      .post(link, paramemers, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}
export async function renameDir(
  renameTo: string,
  groupId: string,
  userId: string,
  fileId: string,
  oldName: string
) {
  let paramemers = {
    renameTo: renameTo,
    userId: userId,
    groupId: groupId,
    oldName: oldName,
    fileId: fileId,
  };
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/rename";
  return new Promise((resolve, reject) => {
    axios
      .post(link, paramemers, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        if (response.data?.success) resolve(response.data);
        else {
          reject();
        }
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {});
  });
}

export async function moveFile(
  groupId: any,
  userId: any,
  fileId: any,
  newFileSelectedName: any,
  currentFolderId: any
) {
  if (checkEmpty(currentFolderId)) currentFolderId = "";
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/moveFileFolder";

  let p = {
    toFolderId: currentFolderId,
    fileSelectedId: fileId,
    groupId: groupId,
    userId: userId,
    newName: newFileSelectedName,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(link, p, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        // console.log(response.data.data);
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function getAboutLimit(param: any) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/getAboutLimit";
  return new Promise((resolve, reject) => {
    axios
      .get(link, {
        params: param,
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function shareFileToGroup(
  groupId: any,
  userId: any,
  groups: any,
  users: any,
  file: any
) {
  let userInfo: any = {};
  let user: any = getUserData();
  userId = user.id;
  userInfo.name = user.username;
  userInfo.first_name = user.first_name;
  userInfo.last_name = user.last_name;
  userInfo.email = user.gmail;

  let groupsFinal = [];
  for (let a = 0; a < groups.length; a++) {
    let d = JSON.parse(JSON.stringify(groups[a]));
    d.img = null;
    groupsFinal.push(d);
  }
  let usersFinal = [];
  for (let a = 0; a < users.length; a++) {
    let d = JSON.parse(JSON.stringify(users[a]));
    d.img = null;
    usersFinal.push(d);
  }

  var token = getToken();
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/shareFileToGroup";
  let p = {
    fileId: file.file_app_id,
    groupId: groupId,
    userId: userId,
    groups: groupsFinal,
    users: usersFinal,
    userInfo: userInfo,
    token: token,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(link, p, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        // console.log(response.data.data);
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function getGroupDesc(userId: any, groupId: any) {
  console.log("userId : ", userId);
  console.log("groupId : ", groupId);
  
  var token = getToken(); //localStorage.getItem("token");
  let param = `?${userId ? "userId=" + userId : ''}${groupId ? "groupId=" + groupId : ''}&token=${token}`
  // console.log("param : ", param);
  
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/getGroupDesc" + param;
  // let p = { userId: userId, groupId: groupId, token: token };
  return new Promise((resolve, reject) => {
    axios
      .get(link, {
        // params: p,
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function getFileObj(userId: any, groupId: any, file: any) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/getFileFolderDesc";
  let p = { userId: userId, groupId: groupId, fileId: file.file_app_id };
  return new Promise((resolve, reject) => {
    if (file.type_ === "FILE") {
      resolve(file);
    } else {
      axios
        .get(link, {
          params: p,
          headers: {
            "Content-Type": "application/json",
            Authorization: getAuthorization(),
          },
        })
        .then(function (response) {
          resolve(response.data.data);
        })
        .catch(function (error) {
          reject(error);
        })
        .finally(function () {
          // always executed
        });
    }
  });
}

export async function deleteRequest(toDeleteFile: any) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/moveFileToTrash";
  let p = { fileId: toDeleteFile.file_app_id, type: toDeleteFile.type_ };
  return new Promise((resolve, reject) => {
    axios
      .post(link, p, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function restore(fileSelected: any) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/restore";
  console.log(fileSelected);
  let p = {
    fileId: fileSelected.file_app_id,
    parentFolderId: fileSelected.parent_folder_id,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(link, p, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}
export async function callDeleteFromTrashAll(groupId:any, userId:any) {
  let link =  window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/deleteFromTrashAll";
  // console.log(fileSelected);
  let p = {
    userId: userId,
    groupId: groupId,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(link, p, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}
export async function deleteFromTrash(
  fileSelected: any,
  groupId: any,
  onlySelectVersion: any
) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/deleteFromTrash";
  // console.log(fileSelected);
  let p = {
    fileId: fileSelected.file_app_id,
    parentFolderId: fileSelected.parent_folder_id,
    type: fileSelected.type_,
    groupId: groupId,
    filePath: fileSelected.file_path,
    fileName: fileSelected.file_name,
    onlyVersion: onlySelectVersion,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(link, p, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function getUserDetail(userId: any) {
  let link: any = window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL;
  if (link?.endsWith("/"))
    link = window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/users/detail/${userId}`;
  else
    link = window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `/api/v1/users/detail/${userId}`;
  return new Promise((resolve, reject) => {
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function getactivitity(
  fileId: any,
  userId: any,
  offsetAc: any,
  limitOfset: any
) {
  let link =
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER +
    "/getActivity?fileId=" +
    fileId +
    "&userId=" +
    userId +
    "&offset=" +
    offsetAc +
    "&limitOfset=" +
    limitOfset;
  return new Promise((resolve, reject) => {
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(async function (response) {
        let datas = response.data.data;

        resolve({ data: datas, total: response.data.total });
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function getFileDir(fileId: any) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/getFileDir?fileId=" + fileId;
  return new Promise((resolve, reject) => {
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}
export async function getLinkDownload(fileId: any) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/getLinkDownload";
  let p = {
    fileId: fileId,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(link, p, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        // console.log(response.data.data);
        resolve({ data: response.data.data, total: response.data.total });
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function addMemberToAccessBackend(
  fileId: any,
  userId: any,
  userSelected: any,
  userUnSelected: any,
  len: any,
  level: any,
  levelperson: any
) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/addMemberToAccess";
  let p = {
    fileId: fileId,
    userId: userId,
    userSelected: userSelected,
    userUnSelected: userUnSelected,
    len: len,
    level: level,
    levelperson: levelperson,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(link, p, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        // console.log(response.data.data);
        resolve({ data: response.data.data, total: response.data.total });
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function getFileByLinkId(linkId: any) {
  let link =
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/getDetailByLink?linkId=" + linkId;
  return new Promise((resolve, reject) => {
    axios
      .get(link, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function checkUserHasAccess(userId: any, fileId: any) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/checkUserHasAccess";
  return new Promise((resolve, reject) => {
    axios
      .get(link, {
        params: {
          userId: userId,
          fileId: fileId,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function getLinkDetail(url: any) {
  url = url?.replace(/\r?\n/g, "");
  let link = window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/crawler/og";
  var token = getToken();
  let param = {
    url: url,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(link, param, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then(async function (response) {
        let data = response.data;
        try {
          data.mainImg = data.images[0].url;
        } catch (e) {}
        resolve(data);
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}

export async function getUrl(url: any, id: any, size: any, type: any) {
  return new Promise((resolve, reject) => {
    if ("post" == type || "chat" == type || "conference" === type) {
      let link =
        window.__RUNTIME_CONFIG__.REACT_APP_FILE_CACHE + "/" + id + "_" + size + ".jpg";
      let urlcache = caches[link];
      if (urlcache === true) {
        resolve(link);
      }
      fetch(link)
        .then((response) => {
          if (response.status === 404) {
            resolve(url);
          } else {
            caches[link] = true;
            resolve(link);
          }
        })
        .catch((error) => {
          // console.log("error", error);
          resolve(url);
        });
    } else {
      if (videoType.includes(type) || imgTypes.includes(type)) {
        let link =
          window.__RUNTIME_CONFIG__.REACT_APP_FILE_CACHE + "/" + id + "_" + size + ".jpg";
        if (videoType.includes(type)) {
          link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_CACHE + "/" + id + "_1024" + ".jpg";
        }
        let urlcache = caches[link];
        if (urlcache === true) {
          resolve(link);
        }
        fetch(link)
          .then((response) => {
            if (response.status === 404) {
              console.log(link + "==> not exist!");
              resolve(url);
            } else {
              caches[link] = true;
              resolve(link);
            }
          })
          .catch((error) => {
            // console.log("error", error);
            resolve(url);
          });
      } else {
        resolve(url);
      }
    }
  });
}



export async function checkURL(link: any) {
  return new Promise((resolve, reject) => {
    

      let urlcache = caches[link];
      if (urlcache === true) {
        resolve(true);
      }
      fetch(link)
        .then((response) => {
          if (response.status === 404) {
            resolve(false);
          } else {
            caches[link] = true;
            resolve(true);
          }
        })
        .catch((error) => {
          // console.log("error", error);
          resolve(false);
        });
   
  });
}



export async function blockDownload(
  fileId: any,
  blockDownload: any,
) {
  let link = window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/blockDownload";
  let p = {
    fileId: fileId,
    blockDownload: blockDownload,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(link, p, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      })
      .then(function (response) {
        // console.log(response.data.data);
        // resolve({ data: response.data.data, total: response.data.total });
        resolve({})
      })
      .catch(function (error) {
        reject(error);
      })
      .finally(function () {
        // always executed
      });
  });
}